"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashString = void 0;
const js_sha3_1 = require("js-sha3");
/**
 * Hashed einen `string` mit Sha3_512.
 *
 * @category Utils
 * @param value
 * @returns Gehashten string
 */
const hashString = (value) => {
    return (0, js_sha3_1.sha3_512)(value);
};
exports.hashString = hashString;
